import axios from 'axios'
import Vue from 'vue'
import qs from 'qs'
import { Message } from 'element-ui';
Vue.prototype.$message = Message;

const tempEngine = (function () {
  var pattern = /\:(\w*[:]*[=]*\w+)(?!})/g;
  return function (template, json) {
    return template.replace(pattern, function (match, key, value) {
      return typeof json[key] == 'undefined' ? ':' + key : json[key];
    });
  }
})();
axios.defaults.timeout = 10000;
// axios.defaults.baseURL = 'http://test-huakepc.eduhuake.cn/smallpargramback';
// axios.defaults.baseURL = 'http://s2t4620884.wicp.vip/smallpargramback';
axios.defaults.baseURL = 'http://mapi.eduscb.com/smallpargramback';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';



// axios.interceptors.request.use(config => {
// // 让每个请求携带token--['token']为自定义key
//   var token = JSON.parse(sessionStorage.getItem('user')).token;
//   // var token = '111';
//   Object.assign(config.headers, { 'token': token });
//   return config;
// },error =>{
// // Do something with request error
//   console.log(error); // for debug
//   Promise.reject(error);
// });

// respone拦截器
// axios.interceptors.response.use(
//   response => response,
//   error =>{
//     console.log('err' + error);// for debug
//     Message({
//       message: '服务器繁忙，请稍后重试',
//       type: 'error',
//       duration: 5 * 1000
//     });
//     return Promise.reject(error);
//   });



// api request 拦截器
axios.interceptors.request.use(
  (request) => {
    request.data = request.data
    return request
  }, (error) => {
    return Promise.reject(error)
  });

//api response 拦截器
axios.interceptors.response.use(
  response => {

    return response;
  },
  error => {
    return Promise.reject(error)
  }
)

// post请求
export const post = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(params))
      .then(response => {
        resolve(response.data)
      }, err => {
        const message_conf = {
          showClose: true,
          message: err.msg,
          type: 'error',
          duration: 2000
        }
        Message(message_conf)
        reject(err)
      })
      .catch((error) => {
        console.log(error)
        const message_conf = {
          showClose: true,
          message: error.msg,
          type: 'error',
          duration: 2000
        }
        Message(message_conf)
        reject(error)
      })
  })
};

// get请求
export const get = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.get(url, {params})
      .then(response => {
        resolve(response.data)
      }, err => {
        const message_conf = {
          showClose: true,
          message: err.msg,
          type: 'error',
          duration: 2000
        }
        Message(message_conf)
        reject(err)
      })
      .catch((error) => {
        console.log(error)
        const message_conf = {
          showClose: true,
          message: error.msg,
          type: 'error',
          duration: 2000
        }
        Message(message_conf)
        reject(error)
      })
  })
};

// get请求
export const del = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.delete(url, {params})
      .then(response => {
        resolve(response.data)
      }, err => {
        const message_conf = {
          showClose: true,
          message: err.msg,
          type: 'error',
          duration: 2000
        }
        Message(message_conf)
        reject(err)
      })
      .catch((error) => {
        console.log(error)
        const message_conf = {
          showClose: true,
          message: error.msg,
          type: 'error',
          duration: 2000
        }
        Message(message_conf)
        reject(error)
      })
  })
};

// get请求
export const put = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(response => {
        resolve(response.data)
      }, err => {
        const message_conf = {
          showClose: true,
          message: err.msg,
          type: 'error',
          duration: 2000
        }
        Message(message_conf)
        reject(err)
      })
      .catch((error) => {
        console.log(error)
        const message_conf = {
          showClose: true,
          message: error.msg,
          type: 'error',
          duration: 2000
        }
        Message(message_conf)
        reject(error)
      })
  })
};
export default {
  get,
  post,
  del,
  put
}



// WEBPACK FOOTER //
// ./src/api/reject.js